var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipse2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 249,
    height: 126,
    viewBox: "0 0 249 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.118,
    y1: 0.186,
    x2: 0.882,
    y2: 0.814,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dee6f5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-16012.009-1987h-248.982c-.006-.528-.009-1.033-.009-1.5a125.363,125.363,0,0,1,2.529-25.091,123.854,123.854,0,0,1,7.254-23.37,124.567,124.567,0,0,1,11.479-21.148,125.351,125.351,0,0,1,15.2-18.425,125.439,125.439,0,0,1,18.426-15.2,124.441,124.441,0,0,1,21.149-11.479,123.848,123.848,0,0,1,23.37-7.254A125.438,125.438,0,0,1-16136.5-2113a125.436,125.436,0,0,1,25.091,2.529,123.878,123.878,0,0,1,23.369,7.254,124.521,124.521,0,0,1,21.148,11.479,125.388,125.388,0,0,1,18.426,15.2,125.416,125.416,0,0,1,15.2,18.425,124.533,124.533,0,0,1,11.479,21.148,123.859,123.859,0,0,1,7.254,23.37A125.363,125.363,0,0,1-16012-1988.5c0,.5,0,1.006-.009,1.5Z",
    transform: "translate(16261 2112.998)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse2);
export default __webpack_public_path__ + "static/media/ellipse-2.6610cc6cba189524b93e0089b7f9891d.svg";
export { ForwardRef as ReactComponent };